document.addEventListener("DOMContentLoaded", function () {
  const passwordInput = document.querySelector(".show_password_input");
  const toggleButton = document.querySelector(".show_password");

  if(passwordInput  && toggleButton)
  {
    toggleButton.addEventListener("click", function () {
        const isPassword = passwordInput.getAttribute("type") === "password";
        passwordInput.setAttribute("type", isPassword ? "text" : "password");
    });
  }
});
document.addEventListener("DOMContentLoaded", function() {
  var params = new URLSearchParams(window.location.search);
  var targetId = params.get("goto");
  if (targetId) {
    var targetElem = document.getElementById(targetId);
    if (targetElem) {
      setTimeout(function() {
        // Calculate the offset position
        var headerOffset = 100; // height in px of your sticky header + extra margin
        var elementPosition = targetElem.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 100);
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  
  /***
  Back to top
  **/
  var backToTopButton = document.getElementById('backToTop');
  if(backToTopButton)
  {
    window.addEventListener('scroll', function () {
        if (window.scrollY > 300) {
        backToTopButton.style.display = 'block';
        } else {
        backToTopButton.style.display = 'none';
        }
    });

    backToTopButton.addEventListener('click', function () {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
    });
    }
  /***
  end Back to top
  **/

});